import TagManager from "react-gtm-module";
import { ApplicationFlowSteps } from "../../route/application/authenticated/application-flow/types";
import { EventActionValue, EventCategory } from "./types";
import { ProductRefType } from "../../context/product-context/types";
import { get } from "../../api/http";

export const dataLayerName = "CustomDataLayer";

const steps: { [key in ApplicationFlowSteps]: string } = {
  COMPANY: "company",
  REGISTRATION: "registration",
  EMAIL_OTP: "email-otp",
  BASIC_ACCOUNT_INFORMATION: "basic-account-information",
  BASIC_ACCOUNT_BENEFITS: "basic-account-benefits",
  REGULATORY_INFORMATION: "regulatory-information",
  POWER_OF_ATTORNEY: "power-of-attorney",
  CARDHOLDER: "cardholder",
  CARDHOLDER_BENEFITS: "cardholder-benefits",
  CHOOSE_SIGNATORIES: "choose-signatories",
  SUMMARY: "confirm-pdf-details",
  SIGN: "sign",
  COMPANY_ONLINE: "company-online",
  UPLOAD_ATTACHMENTS: "upload-attachments",
  DASHBOARD: "dashboard",
};

async function enableGTM() {
  const gtmId = await get("/commercial/api/gtm-container").then((response) =>
    response.text(),
  );

  if (gtmId) {
    const tagManagerArgs = {
      gtmId,
      dataLayer: {
        "gtm.whitelist": [
          "baut",
          "av",
          "gas",
          "u",
          "remm",
          "smm",
          "f",
          "vis",
          "d",
          "v",
          "e",
          "c",
          "ytl",
          "tl",
          "sdl",
          "lcl",
          "fsl",
          "cl",
          "evl",
          "ua",
          "fls",
          "flc",
          "sp",
          "awct",
        ],
      },
      dataLayerName,
    };

    /* With the initialization of this Tag manager the following codes will be inserted on each of the pages in the app:

      <head>
        ...
        <script>
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(*${tagManagerArgs.dataLayer}*) // see the tagManagerArgs constant above
        </script>
        <script>
          (function(w,d,s,l,i){w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js', ${JSON.stringify(events).slice(1, -1)}});
            var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+'${gtm_auth}${gtm_preview}
            &gtm_cookies_win=x';
            f.parentNode.insertBefore(j,f);
          })(window,document,'script','${dataLayerName}','${id}');`
        </script>
        ...
      </head>
      <body>
        ...
        <noscript>
          <iframe src="https://www.googletagmanager.com/ns.html?id=${id}${gtm_auth}${gtm_preview}&gtm_cookies_win=x"
          height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>
        </noscript>
        ...
      </body>

    */
    TagManager.initialize(tagManagerArgs);
  }
}

function trackVirtualPageView(
  step: ApplicationFlowSteps,
  product: ProductRefType,
  language: string,
): void {
  if (!step || !product || !language) {
    return;
  }
  const pageViewDataLayer = {
    event: "GTM-virtual-pageview",
    pageView: `${language}/swisscard-online-tool/${product}/${steps[step]}`,
    language,
    card: product,
    step: steps[step],
  };

  TagManager.dataLayer({
    dataLayer: pageViewDataLayer,
    dataLayerName,
  });
}

function trackEvent(
  category: EventCategory,
  action: EventActionValue | number | string,
): void {
  const eventDataLayer = {
    event: "GTM-SwissTool",
    eventCategory: category,
    eventAction: action,
  };

  TagManager.dataLayer({
    dataLayer: eventDataLayer,
    dataLayerName,
  });
}

const GTM = {
  enableGTM,
  trackVirtualPageView,
  trackEvent,
};

export default GTM;
